import { useState, useEffect, useCallback } from "react";

const KEY = "doozygo_admin_theme";

const getStored = () => {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" || v === "dark" || v === "system" ? v : "system";
  } catch {
    return "system";
  }
};

const systemPrefersDark = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-color-scheme: dark)").matches;

const resolve = (t) => (t === "system" ? systemPrefersDark() : t === "dark");

// Admin theme: 'system' (default) | 'light' | 'dark', persisted to localStorage.
export default function useAdminTheme() {
  const [theme, setThemeState] = useState(getStored);
  const [isDark, setIsDark] = useState(() => resolve(getStored()));

  const setTheme = useCallback((t) => {
    try {
      localStorage.setItem(KEY, t);
    } catch {
      /* ignore */
    }
    setThemeState(t);
    setIsDark(resolve(t));
  }, []);

  // React to OS theme changes while on "system"
  useEffect(() => {
    if (!window.matchMedia) return;
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = () => {
      if (getStored() === "system") setIsDark(mq.matches);
    };
    if (mq.addEventListener) mq.addEventListener("change", handler);
    else mq.addListener(handler);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", handler);
      else mq.removeListener(handler);
    };
  }, []);

  return { theme, setTheme, isDark };
}
